import { FC } from 'react'

import { NodeProps, Position } from '@xyflow/react'

import {
  EditorNodeTemplate,
  NodeHandle
} from 'Automations/nodeDefinitions/components'
import { ReminderExpandedContent } from './ReminderExpandedContent'

export const ReminderEditorNode: FC<NodeProps> = ({ id, selected }) => {
  return (
    <EditorNodeTemplate
      nodeId={id}
      selected={selected}
      minWidth="245px"
      expandedContent={<ReminderExpandedContent nodeId={id} />}
    >
      <EditorNodeTemplate.Rows>
        <EditorNodeTemplate.Row>
          <EditorNodeTemplate.Row.Text>
            Payment reminder sent
          </EditorNodeTemplate.Row.Text>
          <NodeHandle
            nodeId={id}
            type="source"
            position={Position.Right}
            selected={selected}
            insideRow
          />
        </EditorNodeTemplate.Row>
      </EditorNodeTemplate.Rows>

      <NodeHandle
        nodeId={id}
        type="target"
        position={Position.Left}
        selected={selected}
      />
    </EditorNodeTemplate>
  )
}
